import { getStore } from "store";
import { activeBrandClear } from "actions/scope";

export default function (nextState, replace, callback) {
    const store = getStore();
    const { scope } = store.getState();
    if (scope.brand && scope.brand._id) {
        store.dispatch(activeBrandClear());
    }
    callback();
}
